module.exports = __webpack_public_path__ + "img/Drop Down.d8f48a4f.png";